import { useParams } from "react-router-dom";
import React from "react";
import { useState} from "react";
import { useTranslation } from "react-i18next";
import Contact from "../Home/Contact";
import { Spinner } from "react-bootstrap";
import { useTranslatedVideos } from "./WorkVideos";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom"; // Importa useLocation
import { useLocation } from "react-router-dom"; // Importa useLocation

function getEmbedUrl(url) {
   if (url.includes("youtube.com") || url.includes("youtu.be")) {
      return url.includes("embed") ? url : url.replace("watch?v=", "embed/");
   } else if (url.includes("instagram.com")) {
      return `https://www.instagram.com/p/${
         url.split("/p/")[1].split("/")[0]
      }/embed/`;
   }
   return url;
}

const WorkDetail = () => {
   const [loadedVideos, setLoadedVideos] = useState({}); // Estado para controlar carga de videos
   const { t, i18n } = useTranslation();
   const videos = useTranslatedVideos();
   const { videoName } = useParams();
   const video = videos.find((v) => v.slug === videoName);
   const location = useLocation();
   const selectedLanguage = location.pathname.startsWith("/en") ? "en" : "es";

   // Determinamos el idioma preferiblemente desde la URL o el estado de i18n
   const isEn = i18n.language === "en" || location.pathname.startsWith("/en");
   const basePath = isEn ? "/en" : "";

   if (!video) {
      return <p>Video no encontrado.</p>;
   }

   // URL Canónica dinámica según el idioma
   const canonicalUrl = `https://www.joancompany.es${basePath}/trabajos/${video.slug}`;

   return (
      <div className="works">
         <Helmet>
            <title key="title">{video.title}</title>
            <meta key="description" name="description" content={video.desc} />
            <link
               rel="canonical"
               href={canonicalUrl}
            />
            <meta property="og:image" content={video.fpimg} />
            <meta property="og:title" content={video.title} />
            <meta property="og:description" content={video.desc} />
            <link rel="image_src" href={video.fpimg} />
            <link
               rel="alternate"
               href={`https://www.joancompany.es/trabajos/${video.slug}`}
               hreflang="es"
            />
            <link
               rel="alternate"
               href={`https://www.joancompany.es/en/trabajos/${video.slug}`}
               hreflang="en"
            />
            <html lang={i18n.language} />
         </Helmet>
         <div className="works-container">
            <h1>{video.title}</h1>
            <h2>{video.desc}</h2>
         </div>
         <div className="page-breadcrumb">
            <Link to={`${basePath}/`} title="Home">
               {t("home")}
            </Link>
            <span id="sp">/</span>
            <Link to={`${basePath}/trabajos`} title="Trabajos">
               {t("works")}
            </Link>
            <span>/</span>
            <span className="breadcrumb-title">{video.title}</span>
         </div>
         <div className="works-content">
            <div
               className={`work-video-container ${
                  video.type === "yt" ? "video-yt" : "video-insta"
               }`}
            >
               <div className="work-video-loader">
                  {!loadedVideos[video.id] && (
                     <div
                        className="expoyt-project-loader"
                        style={{
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           width: "100%",
                           height: "100%",
                        }}
                     >
                        <Spinner
                           animation="border"
                           style={{
                              color: "var(--imp-text-color)",
                              width: "3rem",
                              height: "3rem",
                           }}
                        />
                     </div>
                  )}
                  <iframe
                     width="100%"
                     height="100%"
                     src={getEmbedUrl(video.videoUrl)}
                     title={video.title}
                     frameBorder="0"
                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                     allowFullScreen
                     onLoad={() =>
                        setLoadedVideos((prev) => ({
                           ...prev,
                           [video.id]: true,
                        }))
                     }
                     style={{
                        display: loadedVideos[video.id] ? "block" : "none",
                     }}
                  />
               </div>
            </div>
         </div>
         <Contact />
      </div>
   );
};

export default WorkDetail;
